import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle, XCircle } from "@phosphor-icons/react";
import api from "@/lib/api";

export default function VerifyEmail() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("working");

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("error"));
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6">
      <div className="text-center max-w-md fade-up">
        {status === "working" && <p className="mono text-sm text-zinc-500">verifying<span className="cursor-blink">_</span></p>}
        {status === "ok" && (
          <>
            <CheckCircle size={44} className="text-green-500 mx-auto mb-5" weight="bold" />
            <h1 className="font-head text-2xl font-black tracking-tighter mb-2">EMAIL VERIFIED</h1>
            <p className="text-zinc-400 text-sm mb-8">Your account is verified. Links you create will skip the interstitial after 24h.</p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle size={44} className="text-red-500 mx-auto mb-5" weight="bold" />
            <h1 className="font-head text-2xl font-black tracking-tighter mb-2">INVALID LINK</h1>
            <p className="text-zinc-400 text-sm mb-8">This verification link is invalid or has expired.</p>
          </>
        )}
        {status !== "working" && (
          <button onClick={() => navigate("/dashboard")} data-testid="verify-continue-btn"
            className="mono text-xs uppercase tracking-widest border border-white/20 px-6 py-3 hover:border-white transition-colors">
            Continue to dashboard
          </button>
        )}
      </div>
    </div>
  );
}
